import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
    } = config;

    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;
    this.pxCorrection = -300;

    if(this.accordions && this.accordions.length !== 0){
      this.bindEvents();

      const url = location.href;
      const id = url.split('#');

      if (!!id[1]) {
        let accordionToClick = document.querySelector(`#${id[1]}`);
        let accordionToScroll = document.querySelector('#' + id[1]);
        let headerOffset = document.querySelector('.header').offsetHeight;
        let elementPosition = accordionToScroll.offsetTop;
        let offsetPosition = elementPosition + headerOffset;
        if(!accordionToClick.classList.contains('ns-accordion')) {
          accordionToClick.closest('.ns-accordion__content').previousElementSibling.click();
          setTimeout(() => {
            accordionToScroll.scrollIntoView({
              block: "start", 
              behavior: "smooth"
            });
          }, 1000);
        } else if (accordionToClick) {
          const accordionHeader = accordionToClick.querySelector('.ns-accordion__head');
          const accordionHeaderHeight = accordionHeader.offsetHeight;
          setTimeout(() => {
            accordionHeader.click();
            window.scrollTo({
              top: (offsetPosition + accordionHeaderHeight + this.pxCorrection),
              behavior: "smooth"
            });
          }, 1000);
        } else {
          setTimeout(() => {
            window.scrollTo({
              top: (offsetPosition + this.pxCorrection),
              behavior: "smooth"
            });
          }, 1000);
        }
      }

    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        if(el.classList.contains('active')){
          Helper.slideClose(el.nextElementSibling);
          el.classList.remove('active');
        } else{
          el.classList.add('active');
          Helper.slideOpen(el.nextElementSibling, true, 300);
        }
        this.toggleAriaExpanded(el)
      });
    });
  }

  toggleAriaExpanded(button){
    let aria = button.getAttribute('aria-expanded');
    
    if(aria=="false"){
      aria = "true";
    } else{
      aria = "false";
    }
    button.ariaExpanded = aria;
  }

}

export default Accordion;
